import React from 'react'
import './seperator.css'

const Seperator = () => {
  return (
    <div className='separator'></div>
  )
}
export default Seperator